import { hasExpired } from '../util/subscriptionDetails';
import { userIsCurrentRootGroupCreator } from '../util/UtilFunctions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Workspace = any;

export const getActiveWorkspace = (groupsList: Workspace[] | undefined, currentUserGroup: string | null) => {
  if (!groupsList) return undefined;
  return groupsList.find((group) => currentUserGroup === (group.id?.S || group.id));
};

export const getIsRootWorkspace = (activeWorkspace: Workspace | undefined): boolean => {
  if (!activeWorkspace) return false;
  return (activeWorkspace.parent?.S || activeWorkspace.parent) === 'root';
};

export const getPathSecondItem = (location: { pathname: string }): string | undefined =>
  location.pathname.split('/')[2];

export const getCurrentUserGroup = (groupsList: Workspace[]): string | undefined => {
  const stored = window.localStorage.getItem('currentUserGroup');
  if (stored && groupsList.find((group) => group.id.S === stored)) return stored;
  if (groupsList?.[0]) {
    window.localStorage.setItem('currentUserGroup', groupsList[0].id.S);
    return groupsList[0].id.S;
  }
  return undefined;
};

export const handleLoginRedirect = (
  getGroupsListProcess: { data: Workspace[] },
  currentUserGroup: string | null,
  loginProcessOngoing: boolean,
  history: { push: (path: string) => void },
) => {
  const activeWorkspace = getActiveWorkspace(getGroupsListProcess.data, currentUserGroup);
  const isRoot = getIsRootWorkspace(activeWorkspace);
  if (isRoot && loginProcessOngoing) history.push('/in/account/workspace');
  else if (!isRoot && loginProcessOngoing) history.push('/in/folder/root');
};

export const getIsWorkspaceExpired = (
  getGroupsListProcess: { data: Workspace[] },
  currentUserInfo: Workspace,
  currentUserGroup: string,
): boolean => {
  const isCreator = userIsCurrentRootGroupCreator(getGroupsListProcess.data, currentUserInfo, currentUserGroup);
  if (!isCreator) return false;
  const rootGroup = getGroupsListProcess.data.find((group) => group.id.S === currentUserGroup);
  return hasExpired(rootGroup);
};
